"use client";
import React, { useMemo } from 'react';
import { AbTestingSdk } from '@sravni/ab-testing-sdk/lib/browser';
import { DEFAULT_VALUE, AbTestingContext } from './Context.js';

function ControlledAbTestingProvider(props) {
    const { value: params, children } = props;
    const sdk = useMemo(() => (params ? new AbTestingSdk(params) : DEFAULT_VALUE), [params]);
    return React.createElement(AbTestingContext.Provider, { value: sdk }, children);
}

export { ControlledAbTestingProvider };
//# sourceMappingURL=Controlled.js.map
